import { useRef, useEffect, useState } from 'react';
import { EditorState } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import { oneDark } from '@codemirror/theme-one-dark';
import { quietlight } from '@uiw/codemirror-themes-all';
import { buildPythonEditorExtensions, DEFAULT_EDITOR_SETTINGS } from '../editor/codemirrorConfig';
import { useTheme } from '../context/ThemeContext';

function getThemeExt(siteTheme) {
  return siteTheme === 'dark' ? oneDark : quietlight;
}

export default function SolutionCodeBlock({ code = '', theme = 'dark', editorSettings }) {
  const containerRef = useRef(null);
  const viewRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const { theme: siteTheme } = useTheme();

  useEffect(() => {
    if (!containerRef.current) return;

    const themeExt = getThemeExt(siteTheme);
    const extensions = buildPythonEditorExtensions({
      settings: { ...DEFAULT_EDITOR_SETTINGS, ...(editorSettings ?? {}), lineNumbers: true },
      themeExt,
      height: undefined,
      readOnly: true,
    });

    const state = EditorState.create({
      doc: code,
      extensions,
    });

    const view = new EditorView({
      state,
      parent: containerRef.current,
    });

    viewRef.current = view;

    return () => {
      view.destroy();
      viewRef.current = null;
    };
  }, [siteTheme, editorSettings, code]);

  useEffect(() => {
    const view = viewRef.current;
    if (!view) return;
    const currentDoc = view.state.doc.toString();
    if (code !== currentDoc) {
      view.dispatch({
        changes: { from: 0, to: currentDoc.length, insert: code },
      });
    }
  }, [code]);

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="solution-code-block">
      <div className="solution-code-block-toolbar">
        <button
          type="button"
          className="btn btn-outline btn-sm solution-code-copy-btn"
          onClick={handleCopy}
          title="Копировать код"
        >
          {copied ? 'Скопировано' : 'Копировать'}
        </button>
      </div>
      <div className="solution-code-block-editor" ref={containerRef} />
    </div>
  );
}
